export default error => {
  try {
    if (error.message) {
      return error.message;
    }
    return error;
  } catch (e) {
    return error;
  }
};
